import React from 'react';
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";

class AppInputPasswordView extends React.Component {

    state = {
        showPassword: false,
    };

    handleClickShowPassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        });
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };


    render() {

        const {id, name, value, label, required, onChange, block = true, labelWidth} = this.props;

        let style = {};
        if (block) {
            style.width = '100%'
        }

        let newLabel = label;
        if (required) {
            newLabel += ' * ';
        }

        return (
            <FormControl variant="outlined" style={style}>
                <InputLabel htmlFor={id}>{newLabel}</InputLabel>
                <OutlinedInput
                    labelWidth={labelWidth}
                    id={id}
                    name={name}
                    value={value}
                    type={this.state.showPassword ? 'text' : 'password'}
                    onChange={onChange}
                    required={required}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPassword}
                                onMouseDown={this.handleMouseDownPassword}
                                edge="end"
                            >
                                {this.state.showPassword ? <Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
        );
    }
}

export default AppInputPasswordView